var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-box"},[_c('el-button',{staticClass:"get-code",attrs:{"type":"danger","disabled":_vm.comDisabled,"round":""},on:{"click":_vm.getCode}},[_vm._v(" "+_vm._s(_vm.text == _vm.$t('login.hqyzm') ? _vm.text : _vm.text + 's'+ _vm.$t('login.get'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }